export function formatInr(n) {
  const v = Number(n);
  if (!Number.isFinite(v)) return "—";
  return `₹${v.toLocaleString("en-IN", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  })}`;
}

/** e.g. `2026-05`, `2026-05-01` → "May, 2026" */
export function formatMonthLabel(value) {
  const s = String(value || "").trim();
  if (!s) return "—";

  const ym = s.match(/^(\d{4})-(\d{2})/);
  if (ym) {
    const y = Number(ym[1]);
    const m = Number(ym[2]);
    if (m >= 1 && m <= 12) {
      const d = new Date(y, m - 1, 1);
      const monthName = d.toLocaleString("en-IN", { month: "long" });
      return `${monthName}, ${y}`;
    }
  }

  const parsed = new Date(s);
  if (!Number.isNaN(parsed.getTime())) {
    const monthName = parsed.toLocaleString("en-IN", { month: "long" });
    return `${monthName}, ${parsed.getFullYear()}`;
  }

  return s;
}
